import React, {Component} from 'react';
import ApiActions from 'go/actions/api';
import {API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS} from 'common/types';
import {Container, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import ResultsList from './ResultsList';
import {connect} from 'react-redux';

const defaultStartingPage = 1;

export class SearchResultsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: true,
      pageNum: defaultStartingPage,
    };
  }

  componentDidMount() {
    this.getSearchResultsAndUpdateState(defaultStartingPage);
  }

  componentDidUpdate(prevProps) {
    let {searchType, searchQuery} = this.props.match.params;
    let {searchType: searchTypeOld, searchQuery: searchQueryOld} = prevProps.match.params;
    if (searchType !== searchTypeOld || searchQuery !== searchQueryOld) {
      this.getSearchResultsAndUpdateState(defaultStartingPage);
    }
  }

  getSearchResultsAndUpdateState = (newPage) => {
    const {token, match} = this.props;
    const {searchType, searchQuery} = match.params;
    const apiConfig = config[searchType];
    const getSearchResults = () => {
      if (apiConfig) {
        const api = _.get(this.props, apiConfig.api);
        if (api) {
          return api(token, searchQuery, newPage)
            .then((res) => {
              if (res && res.type === apiConfig.successActionType) {
                return res.payload;
              }
              return null;
            })
            .catch((err) => {
              return null;
            });
        }
      }
      return Promise.resolve(null);
    };

    getSearchResults().then((data) => {
      if (data === null) {
        this.setState({
          error: true,
        });
      } else {
        this.setState({
          loading: false,
          totalRecords: data.totalRecords,
          data: data.records,
          config: apiConfig.columns,
          pageNum: newPage,
        });
      }
    });
  };

  render() {
    const {error, loading, data, config, pageNum, totalRecords} = this.state;
    if (error) {
      return <Error />;
    } else if (!loading) {
      return (
        <Container>
          <ResultsList
            header="Search Results"
            data={data}
            config={config}
            page={pageNum}
            handlePageChange={this.getSearchResultsAndUpdateState}
            totalRecords={totalRecords}
          />
        </Container>
      );
    } else {
      return <Loader />;
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getOrganizationByDbaOrLegalName: (token, keywords, page) => {
    const action = ApiActions.organization.getOrganizationByDbaOrLegalName(
      token,
      keywords,
      page
    );
    const response = dispatch(action);
    return response;
  },
});

// Config to search on different fields. Just map the API that needs to be called to get the search results and add config below.
const config = {
  orgName: {
    // Use API name as it is mapped in mapDispatchToProps
    api: 'getOrganizationByDbaOrLegalName',
    successActionType: API_ORG_SEARCH_ON_DBA_LEGALNAME_SUCCESS,
    columns: [
      {
        header: 'Organization Name',
        text: '${rowData.organizationName}',
        linkTo: '/organizationProfile/${rowData.organizationId}',
      },
      {
        header: 'DUNS',
        text: '${rowData.duns}',
      },
      {
        header: 'State',
        text: '${rowData.state}',
      },
    ],
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsContainer);
